export * from './agris-acceso-restringido-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-acceso-restringido-dialog/index.ts